const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Components/appointmentCards/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        termStartLabel: 'Datum:',
        dateToBeDefined: 'Anstehend',
        zustArztLabel: 'Fachperson:',
        standortLabel: 'Standort:',
        clinikLabel: 'Klinik:',
        proc1Label: 'Status:',
        termStartText: '{date}, um {time} Uhr',
        planned: 'Geplant',
        provisionally: 'Provisorisch',
        surgeryHintTitle: 'Wichtige Informationen zur Nahrungsaufnahme vor Ihrem Eingriff',
        surgeryHintText:
            'Klare Flüssigkeiten (Tee, Wasser mit wenig Kohlensäure, schwarzer Kaffee mit oder ohne Zucker, ohne Milch oder Kaffeerahm) bis 2 Std. vor dem geplanten Eingriff (in der Regel, bis Sie Ihr Hause für den Spitaleintritt verlassen). \nLetzte Nahrungsaufnahme (inkl. Milch) soll 6 Stunden vor dem Eintritt erfolgen.',
        duration: 'Dauer:',
    },
    __RELATIVE_SOURCE_FILE__
);
